import React, { useState } from 'react';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import Pagination from '../../components/Pagination/Pagination';
import './AdminSupportPage.css';

const AdminSupportPage = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const supportTickets = [
    { id: 1, ticketNo: 'TKT-001', user: 'John Smith', email: 'john@example.com', subject: 'Payment Issue', category: 'Billing', priority: 'High', status: 'Open', date: '2025-01-15' },
    { id: 2, ticketNo: 'TKT-002', user: 'Sarah Johnson', email: 'sarah@example.com', subject: 'Account Access Problem', category: 'Account', priority: 'Medium', status: 'In Progress', date: '2025-01-14' },
    { id: 3, ticketNo: 'TKT-003', user: 'Mike Brown', email: 'mike@example.com', subject: 'Product Listing Error', category: 'Technical', priority: 'Low', status: 'Resolved', date: '2025-01-13' },
    { id: 4, ticketNo: 'TKT-004', user: 'Emily Davis', email: 'emily@example.com', subject: 'Refund Request', category: 'Billing', priority: 'High', status: 'Open', date: '2025-01-12' },
    { id: 5, ticketNo: 'TKT-005', user: 'David Wilson', email: 'david@example.com', subject: 'Verification Delay', category: 'Verification', priority: 'Medium', status: 'In Progress', date: '2025-01-11' },
    { id: 6, ticketNo: 'TKT-006', user: 'Lisa Anderson', email: 'lisa@example.com', subject: 'Feature Request', category: 'General', priority: 'Low', status: 'Closed', date: '2025-01-10' },
  ];

  const stats = [
    { label: 'Total Tickets', value: '156', color: '#1F396C' },
    { label: 'Open', value: '42', color: '#EF4444' },
    { label: 'In Progress', value: '28', color: '#F59E0B' },
    { label: 'Resolved', value: '86', color: '#10B981' },
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case 'Open': return 'status-open';
      case 'In Progress': return 'status-progress';
      case 'Resolved': return 'status-resolved';
      case 'Closed': return 'status-closed';
      default: return '';
    }
  };

  const getPriorityClass = (priority) => {
    switch (priority) {
      case 'High': return 'priority-high';
      case 'Medium': return 'priority-medium';
      case 'Low': return 'priority-low';
      default: return '';
    }
  };

  const filteredTickets = supportTickets.filter(ticket => {
    if (activeTab === 'all') return true;
    return ticket.status.toLowerCase().replace(' ', '-') === activeTab;
  });

  return (
    <AdminLayout>
      <div className="admin-support-content">
        <div className="support-page-header">
          <div className="support-title-section">
            <h1 className="support-page-title">Support Management</h1>
            <p className="support-page-description">Manage customer support tickets and inquiries</p>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="support-stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="support-stat-card">
              <div className="stat-value" style={{ color: stat.color }}>{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Filter Tabs */}
        <div className="support-filters">
          <div className="filter-tabs">
            <button 
              className={`filter-tab ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              All Tickets
            </button>
            <button 
              className={`filter-tab ${activeTab === 'open' ? 'active' : ''}`}
              onClick={() => setActiveTab('open')}
            >
              Open
            </button>
            <button 
              className={`filter-tab ${activeTab === 'in-progress' ? 'active' : ''}`}
              onClick={() => setActiveTab('in-progress')}
            >
              In Progress
            </button>
            <button 
              className={`filter-tab ${activeTab === 'resolved' ? 'active' : ''}`}
              onClick={() => setActiveTab('resolved')}
            >
              Resolved
            </button>
          </div>
          <div className="support-search-box">
            <input 
              type="text" 
              placeholder="Search tickets..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {/* Tickets Table */}
        <div className="support-table-container">
          <table className="support-table">
            <thead>
              <tr>
                <th>Ticket No</th>
                <th>User</th>
                <th>Subject</th>
                <th>Category</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredTickets.map((ticket) => (
                <tr key={ticket.id}>
                  <td className="ticket-no">{ticket.ticketNo}</td>
                  <td>
                    <div className="user-info">
                      <span className="user-name">{ticket.user}</span>
                      <span className="user-email">{ticket.email}</span>
                    </div>
                  </td>
                  <td className="ticket-subject">{ticket.subject}</td>
                  <td>{ticket.category}</td>
                  <td>
                    <span className={`priority-badge ${getPriorityClass(ticket.priority)}`}>
                      {ticket.priority}
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${getStatusClass(ticket.status)}`}>
                      {ticket.status}
                    </span>
                  </td>
                  <td>{ticket.date}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="action-btn view-btn" title="View">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                      <button className="action-btn reply-btn" title="Reply">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M6 10L2 6L6 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 14V9C14 8.20435 13.6839 7.44129 13.1213 6.87868C12.5587 6.31607 11.7956 6 11 6H2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <Pagination currentPage={currentPage} totalPages={3} onPageChange={setCurrentPage} />
      </div>
    </AdminLayout>
  );
};

export default AdminSupportPage;
